import { createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("メッセージ予約の編集")
const _hoisted_2 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "mb-2 leading-7 text-sm font-medium text-gray-500" }, "対象生徒", -1)
const _hoisted_4 = {
  key: 0,
  class: "mb-6 flex flex-wrap border-b border-gray-500"
}
const _hoisted_5 = { class: "text-sm font-medium" }
const _hoisted_6 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " メッセージ対象の絞り込み方法 ", -1)
const _hoisted_8 = { class: "p-4 flex justify-around bg-primary-100 rounded-md" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "group",
  class: "pl-3"
}, "グループ", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", {
  for: "school",
  class: "pl-3"
}, "スクール", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  for: "classroom",
  class: "pl-3"
}, "教室", -1)
const _hoisted_14 = {
  key: 2,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "mt-2 w-full text-center text-gray-500 text-sm" }, " ※ グループを選択しない場合、全生徒にメッセージが送信されます ", -1)
const _hoisted_16 = {
  key: 3,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "mt-2 w-full text-center text-gray-500 text-sm" }, " ※ スクールを選択しない場合、全生徒にメッセージが送信されます ", -1)
const _hoisted_18 = {
  key: 4,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "mt-2 w-full text-center text-gray-500 text-sm" }, " ※ 教室を選択しない場合、全生徒にメッセージが送信されます ", -1)
const _hoisted_20 = {
  key: 5,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_21 = {
  key: 6,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_22 = { class: "w-full" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "mb-1 font-medium text-sm text-gray-500" }, "送信予定画像", -1)
const _hoisted_24 = { class: "w-full flex items-center overflow-x-scroll" }
const _hoisted_25 = { class: "relative w-20 h-20 mr-2" }
const _hoisted_26 = { key: 7 }
const _hoisted_27 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_28 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_29 = { class: "w-full" }
const _hoisted_30 = /*#__PURE__*/_createVNode("p", { class: "mb-1 font-medium text-sm text-gray-500" }, "送信予定画像", -1)
const _hoisted_31 = { class: "w-full flex items-center overflow-x-scroll" }
const _hoisted_32 = { class: "relative w-20 h-20 mr-2" }
const _hoisted_33 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_34 = { class: "p-4 flex flex-col items-center rounded-md border-2 border-gray-200" }
const _hoisted_35 = {
  key: 0,
  class: "w-full flex items-center"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("p", null, "繰り返し終了日", -1)
const _hoisted_37 = { class: "mr-6 text-gray-500 font-medium text-sm" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 予約削除 ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_text_area = _resolveComponent("m-text-area")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      (_ctx.toType == 'students')
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.selectedStudents.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedStudents, (student) => {
                    return (_openBlock(), _createBlock("div", {
                      key: student.ref.id,
                      class: "p-1 pl-2 mb-2 mr-3 flex items-center rounded-md border border-secondary-500"
                    }, [
                      _createVNode("p", _hoisted_5, _toDisplayString(student.data.name), 1),
                      _createVNode("div", {
                        class: "p-1 ml-1 text-gray-500 cursor-pointer",
                        onClick: ($event: any) => (_ctx.removeStudent(student.ref.id))
                      }, [
                        _createVNode(_component_m_icon, { type: "close" })
                      ], 8, ["onClick"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode("div", null, [
                _createVNode("input", {
                  id: "group",
                  type: "radio",
                  name: "group",
                  checked: _ctx.toType == 'group',
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toType = 'group'))
                }, null, 40, ["checked"]),
                _hoisted_9
              ]),
              (_ctx.isAdmin)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode("input", {
                      id: "school",
                      type: "radio",
                      name: "school",
                      checked: _ctx.toType == 'school',
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toType = 'school'))
                    }, null, 40, ["checked"]),
                    _hoisted_11
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode("input", {
                      id: "classroom",
                      type: "radio",
                      name: "classroom",
                      checked: _ctx.toType == 'classroom',
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toType = 'classroom'))
                    }, null, 40, ["checked"]),
                    _hoisted_13
                  ]))
            ])
          ])),
      (_ctx.toType == 'group')
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode(_component_m_select_box, {
              key: "ref.id",
              label: "対象グループ",
              name: "group",
              placeholder: "全て",
              options: _ctx.groups,
              value: _ctx.selectedGroupId,
              "value-key": "ref.id",
              "text-key": "data.title",
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedGroupId = $event))
            }, null, 8, ["options", "value"]),
            _hoisted_15
          ]))
        : (_ctx.toType == 'school')
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              _createVNode(_component_m_select_box, {
                key: "ref.id",
                label: "スクール",
                name: "school",
                placeholder: "全て",
                options: _ctx.schools,
                value: _ctx.selectSchoolId,
                "value-key": "ref.id",
                "text-key": "data.name",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectSchoolId = $event))
              }, null, 8, ["options", "value"]),
              _hoisted_17
            ]))
          : (_ctx.toType == 'classroom')
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                _createVNode(_component_m_select_box, {
                  key: "ref.id",
                  label: "教室",
                  name: "classroom",
                  placeholder: "全て",
                  options: _ctx.classrooms,
                  value: _ctx.selectClassroomId,
                  "value-key": "ref.id",
                  "text-key": "data.name",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectClassroomId = $event))
                }, null, 8, ["options", "value"]),
                _hoisted_19
              ]))
            : _createCommentVNode("", true),
      (_ctx.messageRegularlyReservation.data.messageType == 'text')
        ? (_openBlock(), _createBlock("div", _hoisted_20, [
            _createVNode(_component_m_text_area, {
              label: "メッセージ内容",
              name: "message",
              placeholder: "メッセージを入力",
              value: _ctx.message,
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.message = $event))
            }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.messageRegularlyReservation.data.messageType == 'image')
        ? (_openBlock(), _createBlock("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode("img", {
                    src: _ctx.messageRegularlyReservation.data.messageText,
                    alt: "Upload Image",
                    class: "w-16 h-16 mx-2 my-2 object-cover rounded-md border-2 border-gray-200"
                  }, null, 8, ["src"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.messageRegularlyReservation.data.messageType == 'multiple')
        ? (_openBlock(), _createBlock("div", _hoisted_26, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messageRegularlyReservation.data
            .messageContents, (messageContent, i) => {
              return (_openBlock(), _createBlock("div", { key: i }, [
                (messageContent.type == 'text')
                  ? (_openBlock(), _createBlock("div", _hoisted_27, [
                      _createVNode(_component_m_text_area, {
                        label: "メッセージ内容",
                        name: "message",
                        placeholder: "メッセージを入力",
                        value: _ctx.message,
                        onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.message = $event))
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true),
                (messageContent.type == 'image')
                  ? (_openBlock(), _createBlock("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode("div", _hoisted_31, [
                          _createVNode("div", _hoisted_32, [
                            _createVNode("img", {
                              src: messageContent.text,
                              alt: "Upload Image",
                              class: "w-16 h-16 mx-2 my-2 object-cover rounded-md border-2 border-gray-200"
                            }, null, 8, ["src"])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_33, [
        _createVNode("div", _hoisted_34, [
          _createVNode(_component_m_text_field, {
            label: "送信予定日",
            name: "day",
            type: "date",
            placeholder: "2020/11/22",
            value: _ctx.reserveDay,
            class: "mb-6",
            onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.reserveDay = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_m_text_field, {
            label: "送信予定時間",
            name: "time",
            type: "time",
            placeholder: "18:00",
            value: _ctx.reserveTime,
            class: "mb-6",
            onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.reserveTime = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_m_select_box, {
            key: "id",
            label: "繰り返し設定",
            placeholder: "繰り返し頻度",
            name: "regular",
            options: _ctx.regularPatternOptions,
            value: _ctx.selectedRegularPattern,
            "value-key": "id",
            "text-key": "text",
            class: "mb-6",
            onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedRegularPattern = $event))
          }, null, 8, ["options", "value"]),
          (_ctx.existDeletionTime)
            ? (_openBlock(), _createBlock("div", _hoisted_35, [
                _createVNode(_component_m_text_field, {
                  label: "繰り返し終了日",
                  name: "deletionDay",
                  type: "date",
                  placeholder: "2020/11/22",
                  value: _ctx.deletionDay,
                  class: "mb-6 flex-1",
                  onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deletionDay = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_m_button, {
                  color: "gray-500",
                  text: "",
                  size: "sm",
                  class: "ml-2 flex-0",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.existDeletionTime = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_m_icon, { type: "trash" })
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(_component_m_button, {
                key: 1,
                text: "",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.existDeletionTime = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_m_icon, {
                    type: "plus",
                    class: "mr-2"
                  }),
                  _hoisted_36
                ]),
                _: 1
              }))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("p", _hoisted_37, " 対象生徒: " + _toDisplayString(_ctx.filteredStudents.length) + "人 ", 1),
      _createVNode(_component_m_button, {
        color: "red-400",
        "hover-color": "red-500",
        outline: "",
        class: "mr-4",
        onClick: _ctx.deleteMessageRegularlyReservation
      }, {
        default: _withCtx(() => [
          _hoisted_38
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.updateMessageRegularlyReservation
      }, {
        default: _withCtx(() => [
          _hoisted_39
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}